var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.854 0C.834 0 0 .85 0 1.889v13.458C0 16.255.731 17 1.622 17h15.756c.89 0 1.622-.745 1.622-1.653V4.487c0-.908-.731-1.654-1.622-1.654H16.22V.473A.486.486 0 0 0 15.756 0H1.854zm0 .944h13.439v1.89H1.853a.924.924 0 0 1-.926-.945c0-.532.405-.945.927-.945zM.927 3.52c.273.162.59.258.927.258 5.219-.005 11.038 0 15.524 0a.69.69 0 0 1 .695.708V7.32h-6.72c-.633 0-1.158.535-1.158 1.181v2.833c0 .646.525 1.18 1.159 1.18h6.72v2.834a.69.69 0 0 1-.696.709H1.622a.69.69 0 0 1-.695-.709V3.52zm10.427 4.744h6.72v3.305h-6.72c-.137 0-.232-.097-.232-.236V8.5c0-.139.095-.236.232-.236zm2.317.708a.936.936 0 0 0-.927.945c0 .521.415.944.927.944a.936.936 0 0 0 .927-.944.936.936 0 0 0-.927-.945z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.8adbe4c5dc71c6525a38e179f523eada.svg";
export { ForwardRef as ReactComponent };